import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-core',
	templateUrl:'./CorePluginPage.html',
	styles: [],
	styleUrls:['./CorePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class CorePluginPage
{
	mdContent_83 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.core</groupId>
  <artifactId>core</artifactId>
</dependency>
\`\`\``;
	mdContent_84 = `\`\`\`kotlin
implementation("com.jwebmp.core:jwebmp-core:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_85 = `\`\`\`java
Page<?> page = new Page<>();
Div<?, ?, ?> container = new Div<>();
container.add(new H1<>().setText("Hello"));
container.add(new Paragraph<>().setText("Welcome to JWebMP"));
page.getBody().add(container);
String html = page.toString(true);
\`\`\``;
	mdContent_86 = `\`\`\`java
var button = new Button<>().setText("Click Me");
button.addEvent(new OnClickAdapter(button) {
    @Override
    public void onClick(AjaxCall<?> call, AjaxResponse<?> response) {
        response.addComponent(new Paragraph<>()
            .setText("Button was clicked!"));
    }
});
\`\`\``;
	mdContent_87 = `\`\`\`java
Page<?> page = new Page<>();
Div<?, ?, ?> container = new Div<>();
container.add(new Paragraph<>().setText("Welcome to JWebMP"));
page.getBody().add(container);

String html = page.toString(true);  // full HTML + queued CSS/JS
String json = page.toString();      // JSON representation
\`\`\``;
}
